import React from "react";
import { TutorialContainer } from "../../../_components";

export function WelcomePage() {
  return (
    <div className="chronos-welcome-page">
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/221b1fa8-6782-461d-a35e-a1d1aad92b5a.webm"
      />
      <div className="content-page-wrapper">
        <h2 className="chronos-wizard-page-title">
          Welcome to your new Chronicle!
        </h2>
        {/* GIF */}
        <p className="chronos-wizard-text">
          Chronicles combines maps and timelines to help show not only WHEN, but
          also WHERE, things in your world setting happen!
        </p>
        <p className="chronos-wizard-text">
          In this short set up, we'll establish:
        </p>
        <ul className="chronos-list">
          <li>Your calendar (how time is divided in your Chronicle)</li>
          <li>Your map and cover image</li>
          <li>Your first timeline</li>
        </ul>
        <p className="chronos-wizard-text chronos-wizard-emph">
          Everything can be edited later! So if you're unsure, just click Next!
        </p>
      </div>
    </div>
  );
}
